import type { ReactNode } from 'react';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';

export default function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950 transition-colors">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:bg-background-100 focus:px-4 focus:py-2">Skip to content</a>
      <SiteNav />
      <main id="main">{children}</main>
      <SiteFooter />
    </div>
  );
}